@if (hasAccess) {
  <div class="main-contact-add-btn d-flex justify-content-end">
    <button class="btn-regular-blue" (click)="createRCApplication()">
      <mat-icon fontIcon="add"></mat-icon>
      Add new application
    </button>
  </div>
}
